module.exports = __webpack_public_path__ + "static/media/14_blanco.eb88a25e.svg";